import { useGetAffectationCountQuery } from '@/features/api/endpoints/affectationEndpoints';
import { useGetCurrentUser } from '@/shared/auth/useDirectusUser';
import { Center, Loader, Text } from '@mantine/core';
import { useTranslate } from '@tolgee/react';
import { Navigate, Outlet } from 'react-router-dom';

const AffectationGate = () => {
  const { t } = useTranslate();
  const { status: userStatus, user } = useGetCurrentUser();

  const userId = user?.id;

  const { data: count, isLoading } = useGetAffectationCountQuery(
    {
      filter: {
        user: { _eq: userId },
        status: {
          _eq: 'published',
        },
      },
    },
    { skip: !userId },
  );

  if (userStatus === 'unauthenticated') {
    return <Outlet />;
  }

  if (userStatus === 'loading' || isLoading) {
    return (
      <Center h={200}>
        <Loader size="sm" />
        <Text ml="xs" size="sm" c="dimmed">
          {t('affectation.gate.loading')}
        </Text>
      </Center>
    );
  }

  if (count === 0) {
    return <Navigate to="/onboarding" replace />;
  }

  return <Outlet />;
};

export default AffectationGate;
